module.exports = __webpack_public_path__ + "f7e1d848c92fa3750676fa0c64079326.ogg";


//////////////////
// WEBPACK FOOTER
// ./public/bg.ogg
// module id = 16
// module chunks = 0